import cat4mro from './cat4mro/';
import catalog from './catalog/';
import requestInformation from './request_information/';

export default {
  buyer: {
    pages: {
      ...cat4mro,
      ...catalog,
      ...requestInformation,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/buyer/index.js